/**
 * @module Utilities/Strings
 * @desc Strings helper funtions
 */

import { removeAccents } from './remove-accents';

/**
 * Format string to slug
 */
export function slugify(input = '') {
  return removeAccents(input)
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[()]/g, '')
    .replace(/ /g, '-')
    .replace(/[|^{}%"<>\\`]/g, '')
    .toLowerCase();
}
